import { projectEndpoint } from '@/core/helpers'
import RestApi from '@/core/services/RestApi'

export default {
  data() {
    return {
      externalSegmentsByIntegration: {}
    }
  },

  methods: {
    ensureExternalSegmentsLoaded(integrationIds) {
      const uniqueIds = [...new Set((integrationIds || []).filter(Boolean))]
      uniqueIds.forEach(integrationId => {
        if (!this.externalSegmentsByIntegration[integrationId]) {
          this.fetchExternalSegmentsForIntegration(integrationId)
        }
      })
    },

    fetchExternalSegmentsForIntegration(integrationId) {
      this.$set(this.externalSegmentsByIntegration, integrationId, {
        status: 'loading',
        options: [],
        truncated: false
      })

      RestApi(
        projectEndpoint({
          method: 'get',
          url: `integrations/webhook-stream/${integrationId}/external-segments`
        })
      )
        .then(({ data }) => {
          this.$set(this.externalSegmentsByIntegration, integrationId, {
            status: 'loaded',
            options: Array.isArray(data.segments) ? data.segments : [],
            truncated: !!data.truncated
          })
        })
        .catch(() => {
          this.$set(this.externalSegmentsByIntegration, integrationId, {
            status: 'failed',
            options: [],
            truncated: false
          })
        })
    },

    externalSegmentEntry(integrationId) {
      return (
        this.externalSegmentsByIntegration[integrationId] || {
          status: null,
          options: [],
          truncated: false
        }
      )
    },

    externalSegmentOptions(integrationId) {
      return this.externalSegmentEntry(integrationId).options
    },

    isExternalSegmentsLoading(integrationId) {
      return this.externalSegmentEntry(integrationId).status === 'loading'
    },

    externalSegmentWarningVisible(integrationId, savedId) {
      if (!savedId) {
        return false
      }

      return this.externalSegmentEntry(integrationId).status === 'failed'
    },

    findExternalSegmentName(integrationId, segmentId) {
      if (!segmentId) {
        return null
      }

      const match = this.externalSegmentOptions(integrationId).find(
        segment => segment.id === segmentId
      )

      return match ? match.name : null
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/audiences/mixins/externalSegmentsMixin.js